export var iconsSpecificSettings = {
  Logo2GisRound: {
    defaultSize: 56
  },
  Logo2GisSquare: {
    defaultSize: 56
  },
  LogoAkbars: {
    defaultSize: 44
  },
  LogoAlfabank: {
    defaultSize: 44
  },
  LogoApplemusicRound: {
    defaultSize: 56
  },
  LogoApplemusicSquare: {
    defaultSize: 56
  },
  LogoArvand: {
    defaultSize: 44
  },
  LogoBeelineColor: {
    defaultSize: 56
  },
  LogoBeelineMonochrome: {
    defaultSize: 56
  },
  LogoBspb: {
    defaultSize: 44
  },
  LogoDomrfbank: {
    defaultSize: 44
  },
  LogoEnergobank: {
    defaultSize: 44
  },
  LogoEnergotransbank: {
    defaultSize: 44
  },
  LogoFinambank: {
    defaultSize: 44
  },
  LogoGazprombank: {
    defaultSize: 44
  },
  LogoGoskey: {
    defaultSize: 56
  },
  LogoGosuslugiRound: {
    defaultSize: 56
  },
  LogoGosuslugiSquare: {
    defaultSize: 56
  },
  LogoHomecredit: {
    defaultSize: 44
  },
  LogoHumo: {
    defaultSize: 44
  },
  LogoKinopoiskRound: {
    defaultSize: 56
  },
  LogoKinopoiskSquare: {
    defaultSize: 56
  },
  LogoMinbank: {
    defaultSize: 44
  },
  LogoMir: {
    ratio: 1.9166666666666667
  },
  LogoMkb: {
    defaultSize: 44
  },
  LogoModulbank: {
    defaultSize: 44
  },
  LogoMosEnergoSbit: {
    defaultSize: 46
  },
  LogoNationalStandardBank: {
    defaultSize: 44
  },
  LogoOdnoklassnikiRoundColor: {
    defaultSize: 56
  },
  LogoOdnoklassnikiRoundMonochrome: {
    defaultSize: 56
  },
  LogoOdnoklassnikiSquareColor: {
    defaultSize: 56
  },
  LogoOdnoklassnikiSquareMonochrome: {
    defaultSize: 56
  },
  LogoOpen: {
    defaultSize: 44
  },
  LogoOzonbank: {
    defaultSize: 44
  },
  LogoPochtabank: {
    defaultSize: 44
  },
  LogoPrimsotsbank: {
    defaultSize: 44
  },
  LogoRaiffeisen: {
    defaultSize: 44
  },
  LogoRencredit: {
    defaultSize: 44
  },
  LogoRosbank: {
    defaultSize: 44
  },
  LogoRosselkhozbank: {
    defaultSize: 44
  },
  LogoRsb: {
    defaultSize: 44
  },
  LogoRutubeRoundColor: {
    defaultSize: 56
  },
  LogoRutubeRoundMonochrome: {
    defaultSize: 56
  },
  LogoRutubeSquareColor: {
    defaultSize: 56
  },
  LogoRutubeSquareMonochrome: {
    defaultSize: 56
  },
  LogoSberPayBackground: {
    ratio: 1.9166666666666667
  },
  LogoSberPayStroked: {
    ratio: 1.9166666666666667
  },
  LogoSberbank: {
    defaultSize: 44
  },
  LogoSdco: {
    defaultSize: 44
  },
  LogoSnapchatRound: {
    defaultSize: 56
  },
  LogoSnapchatSquare: {
    defaultSize: 56
  },
  LogoSovcombank: {
    defaultSize: 44
  },
  LogoTelegramRoundColor: {
    defaultSize: 56
  },
  LogoTelegramRoundMonochrome: {
    defaultSize: 56
  },
  LogoTelegramSquareColor: {
    defaultSize: 56
  },
  LogoTelegramSquareMonochrome: {
    defaultSize: 56
  },
  LogoTiktokRound: {
    defaultSize: 56
  },
  LogoTiktokSquare: {
    defaultSize: 56
  },
  LogoTinkoff: {
    defaultSize: 44
  },
  LogoTkbbank: {
    defaultSize: 44
  },
  LogoTochkabank: {
    defaultSize: 44
  },
  LogoUnicreditbank: {
    defaultSize: 44
  },
  LogoUnionPay: {
    ratio: 1.9166666666666667
  },
  LogoUralsib: {
    defaultSize: 44
  },
  LogoVKMusicRound: {
    defaultSize: 56
  },
  LogoVKMusicSquare: {
    defaultSize: 56
  },
  LogoVKPlayRound: {
    defaultSize: 56
  },
  LogoVKPlaySquare: {
    defaultSize: 56
  },
  LogoVKVideoRound: {
    defaultSize: 56
  },
  LogoVKVideoSquare: {
    defaultSize: 56
  },
  LogoVisa: {
    ratio: 1.9166666666666667
  },
  LogoVkClipsRound: {
    defaultSize: 56
  },
  LogoVkClipsSquare: {
    defaultSize: 56
  },
  LogoVkRoundColor: {
    defaultSize: 56
  },
  LogoVkRoundMonochrome: {
    defaultSize: 56
  },
  LogoVkSquareColor: {
    defaultSize: 56
  },
  LogoVkSquareMonochrome: {
    defaultSize: 56
  },
  LogoVkpay: {
    ratio: 1.9166666666666667
  },
  LogoVtb: {
    defaultSize: 44
  },
  LogoWbBank: {
    defaultSize: 44
  },
  LogoWebmoney: {
    defaultSize: 44
  },
  LogoWechatRound: {
    defaultSize: 56
  },
  LogoWechatSquare: {
    defaultSize: 56
  },
  LogoWhatsappRound: {
    defaultSize: 56
  },
  LogoWhatsappSquare: {
    defaultSize: 56
  },
  LogoYaDiskRound: {
    defaultSize: 56
  },
  LogoYaDiskSquare: {
    defaultSize: 56
  },
  LogoYaMapsRound: {
    defaultSize: 56
  },
  LogoYaMapsSquare: {
    defaultSize: 56
  },
  LogoYaMarketRound: {
    defaultSize: 56
  },
  LogoYaMarketSquare: {
    defaultSize: 56
  },
  LogoYandexMusicRound: {
    defaultSize: 56
  },
  LogoYandexMusicSquare: {
    defaultSize: 56
  },
  LogoYandexNavigatorRound: {
    defaultSize: 56
  },
  LogoYandexNavigatorSquare: {
    defaultSize: 56
  },
  LogoYandexPay: {
    ratio: 1.9166666666666667
  },
  LogoYandexProRound: {
    defaultSize: 56
  },
  LogoYandexProSquare: {
    defaultSize: 56
  },
  LogoYandexTaxiRound: {
    defaultSize: 56
  },
  LogoYandexTaxiSquare: {
    defaultSize: 56
  },
  LogoYandexZenRound: {
    defaultSize: 56
  },
  LogoYandexZenSquare: {
    defaultSize: 56
  },
  LogoYoomoney: {
    defaultSize: 44
  }
};
export var iconNamesMap = {
  IconArchiveOutline: 'IconArchiveStroked',
  IconArrowsDownLeft: 'IconArrow2DownLeft',
  IconArrowsDownRight: 'IconArrow2DownRight',
  IconArrowsUpLeft: 'IconArrow2UpLeft',
  IconArrowsUpRight: 'IconArrow2UpRight',
  IconArrowsDown: 'IconArrow1Down',
  IconArrowsLeft: 'IconArrow1Left',
  IconArrowsRight: 'IconArrow1Right',
  IconArrowsUp: 'IconArrow1Up',
  IconBagOutline: 'IconBagStroked',
  IconBanRoundOutline: 'IconBanRoundStroked',
  IconBasketOutline: 'IconBasketStroked',
  IconBellOutline: 'IconBellStroked',
  IconBookmarkOutline: 'IconBookmarkStroked',
  IconBrokenHeartOutline: 'IconBrokenHeartStroked',
  IconCalculatorOutline: 'IconCalculatorStroked',
  IconCalendarOutline: 'IconCalendarStroked',
  IconCallSilentOutline: 'IconCallSilentStroked',
  IconCallingFilled1: 'IconCallingTrue1',
  IconCallingOutline: 'IconCallingStroked',
  IconCallingOutline1: 'IconCallingFalse1',
  IconCameraOutline: 'IconCameraStroked',
  IconCardOutline: 'IconCardStroked',
  IconCaseOutline: 'IconCaseStroked',
  IconChartAltOutline: 'IconChartAltStroked',
  IconChartOutline: 'IconChartStroked',
  IconChatAddMessageOutline: 'IconChatAddMessageStroked',
  IconChatMessageOutline: 'IconChatMessageStroked',
  IconChatPlusMessageOutline: 'IconChatPlusMessageStroked',
  IconCheckMarkCheck: 'IconCheckMark1',
  IconCheckMarkDoubleCheck: 'IconCheckMark2',
  IconCheckOutline: 'IconCheckStroked',
  IconCheckRoundOutline: 'IconCheckRoundStroked',
  IconCheckShieldOutline: 'IconCheckShieldStroked',
  IconCheckSquareOutline: 'IconCheckSquareStroked',
  IconCloseShieldOutline: 'IconCloseShieldStroked',
  IconCloseSquareOutline: 'IconCloseSquareStroked',
  IconCoinsOutline: 'IconCoinsStroked',
  IconCompasOutline: 'IconCompasStroked',
  IconCopyOutline: 'IconCopyStroked',
  IconCouponOutline: 'IconCouponStroked',
  IconDangerOutline: 'IconDangerStroked',
  IconDeskOutline: 'IconDeskStroked',
  IconDocFillOutline: 'IconDocFillStroked',
  IconDotsMessage2Outline: 'IconDotsMessage2Stroked',
  IconDotsMessageOutline: 'IconDotsMessageStroked',
  IconEditPencilOutline: 'IconEditPencilStroked',
  IconEsimOutline: 'IconEsimStroked',
  IconExportOutline: 'IconExportStroked',
  IconEyeCloseOutline: 'IconEyeCloseStroked',
  IconEyeOpenOutline: 'IconEyeOpenStroked',
  IconFileEmptyOutline: 'IconFileEmptyStroked',
  IconFileFillOutline: 'IconFileFillStroked',
  IconFireOutline: 'IconFireStroked',
  IconFlagOutline: 'IconFlagStroked',
  IconGamepadOutline: 'IconGamepadStroked',
  IconGiftOutline: 'IconGiftStroked',
  IconGlobeOutline: 'IconGlobeStroked',
  IconHeadphonesOutline: 'IconHeadphonesStroked',
  IconHeartOutline: 'IconHeartStroked',
  IconHomeOutline: 'IconHomeStroked',
  IconHoneycombsOutline: 'IconHoneycombsStroked',
  IconIPhoneOutline: 'IconIPhoneStroked',
  IconImageBoxOutline: 'IconImageBoxStroked',
  IconInfoOutline: 'IconInfoStroked',
  IconKeySquareOutline: 'IconKeySquareStroked',
  IconLableOutline: 'IconLableStroked',
  IconLayersOutline: 'IconLayersStroked',
  IconLightningCrossedOutFilled: 'IconLightningTrue1',
  IconLightningCrossedOutOutline: 'IconLightningFalse1',
  IconLightningOutline: 'IconLightningStroked',
  IconLockCheckOutline: 'IconLockCheckStroked',
  IconLockCloseOutline: 'IconLockCloseStroked',
  IconLockOpenOutline: 'IconLockOpenStroked',
  IconLockOutline: 'IconLockStroked',
  IconLoginOutline: 'IconLoginStroked',
  IconLogoutOutline: 'IconLogoutStroked',
  IconMailNewOutline: 'IconMailNewStroked',
  IconMailOpenOutline: 'IconMailOpenStroked',
  IconMarkOutline: 'IconMarkStroked',
  IconMinusSquareOutline: 'IconMinusSquareStroked',
  IconMoonOutline: 'IconMoonStroked',
  IconPassportOutline: 'IconPassportStroked',
  IconPhoneOutline: 'IconPhoneStroked',
  IconPieChartOutline: 'IconPieChartStroked',
  IconPinOutline: 'IconPinStroked',
  IconPlayOutline: 'IconPlayStroked',
  IconPlusRoundOutline: 'IconPlusRoundStroked',
  IconPlusRoundStroked: 'IconPlusRoundOutline',
  IconPlusSquareOutline: 'IconPlusSquareStroked',
  IconPowerOutline: 'IconPowerStroked',
  IconQuestionMessage3Outline: 'IconQuestionMessage3Stroked',
  IconQuestionMessageOutline: 'IconQuestionMessageStroked',
  IconQuestionOutline: 'IconQuestionStroked',
  IconRainOutline: 'IconRainStroked',
  IconRobotOutline: 'IconRobotStroked',
  IconSaleCouponOutline: 'IconSaleCouponStroked',
  IconScannerQrOutline: 'IconScannerQrStroked',
  IconScreenMenu2Outline: 'IconScreenMenu2Stroked',
  IconScreenMenuOutline: 'IconScreenMenuStroked',
  IconSearchOutline: 'IconSearchStroked',
  IconSendOutline: 'IconSendStroked',
  IconSettingsOutline: 'IconSettingsStroked',
  IconShareOutline: 'IconShareStroked',
  IconShieldOutline: 'IconShieldStroked',
  IconSimOutline: 'IconSimStroked',
  IconSoundOutline: 'IconSoundStroked',
  IconSpeedOutline: 'IconSpeedStroked',
  IconStarFilled: 'IconStarFull',
  IconStarHalfFilled: 'IconStarHalf',
  IconStarOutline: 'IconStarNo',
  IconStopAndPlayOutline: 'IconStopAndPlayStroked',
  IconStopOutline: 'IconStopStroked',
  IconSunOutline: 'IconSunStroked',
  IconTimeOutline: 'IconTimeStroked',
  IconTrashOutline: 'IconTrashStroked',
  IconUserAddOutline: 'IconUserAddStroked',
  IconUserOutline: 'IconUserStroked',
  IconUsersGroupOutline: 'IconUsersGroupStroked',
  IconVideoFileOutline: 'IconVideoFileStroked',
  IconVideoOutline: 'IconVideoStroked',
  IconVolumeOffOutline: 'IconVolumeOffStroked',
  IconVolumeUpOutline: 'IconVolumeUpStroked',
  IconWalletOutline: 'IconWalletStroked',
  LogoSberPayBackground: 'LogoSberPayFilled',
  LogoTelegramRoundColor: 'LogoTelegramRoundFilled',
  LogoTelegramRoundMonochrome: 'LogoTelegramRoundStroked',
  LogoTelegramSquareColor: 'LogoTelegramSquareFilled',
  LogoTelegramSquareMonochrome: 'LogoTelegramSquareStroked'
};